import { Injectable } from '@angular/core';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {

  constructor(private fuseSidebarService: FuseSidebarService) { }

  open(sidenavName: string): void {
    this.fuseSidebarService.getSidebar(sidenavName).open();
  }

  close(sidenavName: string): void {
    this.fuseSidebarService.getSidebar(sidenavName).close();
  }

  toggle(sidenavName: string): void {
    this.fuseSidebarService.getSidebar(sidenavName).toggleOpen();
  }
}
